export const ds_DividerBlock_Entry = `
    fragment ds_DividerBlock_Entry on ds_DividerBlock_Entry {
        id
        canonicalUid
        divider_ColorPalette
        divider_ColorTheme
        divider_TopSpacing
        divider_ContainerWidth
        divider_FullWidthBackground
    }
`